import { useContext } from 'react'

import { EducationHostedFormContext } from '@percent/education-hosted-form/context/educationHostedForm/EducationHostedFormContext'

export const useEducationHostedForm = () => {
  const context = useContext(EducationHostedFormContext)

  if (context === undefined) {
    throw new Error('useEducationHostedForm must be used within a EducationHostedFormContextController')
  }

  return context
}
